import React, {Component} from 'react';
import withStyles from "@material-ui/core/styles/withStyles";
import Button from "@material-ui/core/Button/index";
import Typography from "@material-ui/core/Typography/index";
import {Color} from '../utis/Styles'
import {MobileChatType} from "../utis/customEnum";
import {languagePackage} from "../utis/localStrings"

class Call extends Component{
	static defaultProps = {
		chatType: MobileChatType.receiveCall,
		peerName: ''
	}

	renderToolbar(isMakeCall) {
		const { classes } = this.props
		if (isMakeCall) {
			return(
				<div className={classes.makeCallToolbarContainer}>
					<Button onClick={() => {
						this.props.cancelCall && this.props.cancelCall()
					}} className={classes.actionButton} color="primary">
						<img style={{width: 60, height: 60}}  src={require('../assets/images/reject.png')} alt={""}/>
					</Button>
				</div>
			)
		}else {
			return (
				<div className={classes.receiveCallToolbarContainer}>
					<Button onClick={() => {
						this.props.refuseCall && this.props.refuseCall()
					}} className={classes.actionButton} color="primary">
						<img style={{width: 60, height: 60}}  src={require('../assets/images/reject.png')} alt={""}/>
					</Button>

					<Button onClick={() => {
						this.props.acceptCall && this.props.acceptCall()
					}} className={classes.actionButton} color="primary">
						<img style={{width: 60, height: 60}}  src={require('../assets/images/accept.png')} alt={""}/>
					</Button>
				</div>
			)
		}
	}
	render() {
		const { classes } = this.props
		let isMakeCall = (this.props.chatType === MobileChatType.makeCall)
		let title = (this.props.chatType === MobileChatType.makeCall) ? languagePackage().Calling : languagePackage().ReceiveCalling
		title = title + ' ' + this.props.peerName

		return(
			<div className={classes.root}>
				<Typography className={classes.title} >
					{title}
				</Typography>

				{this.renderToolbar(isMakeCall)}

			</div>
		)
	}
}

const styles = (theme) => ({
	root: {
		width: '100%',
		height: '100%',
		backgroundColor: Color.black,
		position: 'absolute',
		left: 0,
		right: 0,
		top: 0,
		bottom: 0,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center'
	},
	container: {
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		alignItems: 'center'
	},
	makeCallToolbarContainer: {
		width: '100%',
		position: 'absolute',
		height: 60,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		left: 0,
		bottom: 40,
	},
	receiveCallToolbarContainer: {
		width: '100%',
		position: 'absolute',
		height: 60,
		display: 'flex',
		justifyContent: 'space-around',
		alignItems: 'center',
		left: 0,
		bottom: 40,
	},
	actionButton: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		overflow: 'hidden'
	},
	title: {
		marginLeft: 16,
		marginRight: 16,
		color: Color.white
	}
})

export default withStyles(styles)(Call)
